module.exports = __webpack_public_path__ + "static/img/message.8894d482.png";